import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "list-bubbles mr-4" }
const _hoisted_2 = { class: "list-bubbles__label fs-14 text-gray" }
const _hoisted_3 = { class: "bt-icon" }
const _hoisted_4 = { class: "p-4 mb-3" }
const _hoisted_5 = { class: "fs-20 text-dark" }
const _hoisted_6 = { class: "p-field p-field-with-button" }
const _hoisted_7 = {
  class: "p-field-label",
  for: "person-name"
}
const _hoisted_8 = { class: "bt-icon bt-icon--xs" }
const _hoisted_9 = { class: "ml-2" }
const _hoisted_10 = { class: "form-custom mt-5" }
const _hoisted_11 = {
  class: "p-field-label",
  for: "person-name"
}
const _hoisted_12 = { class: "list-users-collab mt-3" }
const _hoisted_13 = /*#__PURE__*/_createVNode("hr", { class: "my-0" }, null, -1)
const _hoisted_14 = { class: "d-flex justify-content-end p-4 py-3" }
const _hoisted_15 = {
  key: 0,
  class: "app-loader app-loader--contextual"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_InputText = _resolveComponent("InputText")
  const _component_UserItem = _resolveComponent("UserItem")
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_ElPopover = _resolveComponent("ElPopover")
  const _component_ConfirmDeleteUser = _resolveComponent("ConfirmDeleteUser")
  const _component_DialogConfirmTransferOwnership = _resolveComponent("DialogConfirmTransferOwnership")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("AppResource.PlantSharing")), 1),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.plant.sharedWith, (user, userIndex) => {
        return (_openBlock(), _createBlock(_component_Button, {
          key: `user-${userIndex}`,
          class: "p-button-secondary p-button-rounded p-button-sm no-click"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.getUserInitials(user)), 1)
          ]),
          _: 2
        }, 1024))
      }), 128)),
      _createVNode(_component_ElPopover, {
        visible: _ctx.isPopperVisible,
        "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isPopperVisible = $event)),
        trigger: "manual",
        placement: "bottom-end",
        "popper-class": "el-dropdown__popper el-dropdown--context p-0",
        width: "500px"
      }, {
        reference: _withCtx(() => [
          _createVNode(_component_Button, {
            class: "p-button-rounded p-button-icon-only p-button-text",
            onClick: _ctx.togglePopper
          }, {
            default: _withCtx(() => [
              _createVNode("span", _hoisted_3, [
                _createVNode(_component_InlineSvgScoped, {
                  src: 
                                require('@/assets/images/icons/icon-plus-outline.svg')
                            ,
                  "aria-label": "icon-plus-outline"
                }, null, 8, ["src"])
              ])
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createVNode("div", _hoisted_4, [
            _createVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t("AppResource.PlantSharing")), 1),
            _createVNode("form", {
              class: "form-custom mt-5",
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.invitePerson && _ctx.invitePerson(...args)), ["prevent"]))
            }, [
              _createVNode("div", _hoisted_6, [
                _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("AppResource.InviteNewUser")), 1),
                _createVNode(_component_InputText, {
                  id: "person-name",
                  type: "email",
                  required: "true",
                  class: "w-100",
                  placeholder: _ctx.$t('AppResource.InviteUserDescription'),
                  modelValue: _ctx.newUserToShare,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.newUserToShare = $event))
                }, null, 8, ["placeholder", "modelValue"]),
                _createVNode(_component_Button, {
                  class: "p-button-outlined p-button-rounded p-button-field",
                  type: "submit"
                }, {
                  default: _withCtx(() => [
                    _createVNode("span", _hoisted_8, [
                      _createVNode(_component_InlineSvgScoped, {
                        src: 
                                        require('@/assets/images/icons/icon-add-circle-outline.svg')
                                    ,
                        "aria-label": "icon-add-circle-outline"
                      }, null, 8, ["src"])
                    ]),
                    _createVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("AppResource.Invite")), 1)
                  ]),
                  _: 1
                })
              ])
            ], 32),
            _createVNode("div", _hoisted_10, [
              _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("AppResource.UsersUpper")), 1),
              _createVNode("ul", _hoisted_12, [
                _createVNode(_component_UserItem, {
                  user: _ctx.plant.owner,
                  "is-owner": true
                }, null, 8, ["user"]),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.plant.sharedWith, (user, userIndex) => {
                  return (_openBlock(), _createBlock(_component_UserItem, {
                    user: user,
                    key: `user-item-${userIndex}`,
                    "is-me-the-owner": _ctx.isMeTheOwner,
                    onDeleteUser: _ctx.handleDeleteUser,
                    onTransferOwnership: _ctx.handleTransferOwnership
                  }, null, 8, ["user", "is-me-the-owner", "onDeleteUser", "onTransferOwnership"]))
                }), 128))
              ])
            ])
          ]),
          _hoisted_13,
          _createVNode("div", _hoisted_14, [
            _createVNode(_component_Button, {
              class: "p-button-rounded p-button-raised p-button--m",
              onClick: _ctx.togglePopper
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("AppResource.DoneUpper")), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock("div", _hoisted_15, [
                _createVNode(_component_ProgressSpinner)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _createVNode(_component_ConfirmDeleteUser, {
      "is-visible": _ctx.isConfirmDeleteUserVisible,
      onHideDialog: _ctx.toggleConfirmDeleteUser,
      onConfirm: _ctx.deleteUser
    }, null, 8, ["is-visible", "onHideDialog", "onConfirm"]),
    _createVNode(_component_DialogConfirmTransferOwnership, {
      "plant-name": _ctx.plantName,
      "is-visible": _ctx.isVisibleTransferOwnershipConfirm,
      onHideDialog: _ctx.toggleTransferOwnershipConfirm,
      onConfirm: _ctx.transferOwnership
    }, null, 8, ["plant-name", "is-visible", "onHideDialog", "onConfirm"])
  ], 64))
}